import { Directive, Inject, InjectionToken } from '@angular/core';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { NewsFeedModel } from '../news-feed.model';
import { UserService } from '@fi-app/user/user.service';

export const NewsFeedItemHeaderBase_newsItem = new InjectionToken<NewsFeedModel>('NewsFeedItemHeaderBase_newsItem');
export const NewsFeedItemHeaderBase_showForumData = new InjectionToken('NewsFeedItemHeaderBase_showForumData');

@Directive()
export abstract class NewsFeedItemHeaderBase {
    FiStateNames = FiStateNames;

    constructor(
        @Inject(NewsFeedItemHeaderBase_newsItem) public newsItem: NewsFeedModel,
        @Inject(NewsFeedItemHeaderBase_showForumData) public showForumData: boolean,
        private userService: UserService,
    ) {}

    protected openUserProfileDialog(userId: number) {
        this.userService.openUserViewDialog(userId);
    }
}
